/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { Controller } from "react-hook-form";
import {
  Flex,
  Heading,
  Button,
  FormControl,
  FormLabel,
} from "@chakra-ui/react";
import { MultiSelect } from "@progress/kendo-react-dropdowns";
import { useEffect } from "react";
import FormInput from "../../../components/forms/form-Input";
import {
  CASH_CENTER_STATUS,
  CASH_CENTER_TYPES,
  LOADING_BAY_AREAS,
  WEEK_DAYS,
} from "../constants";
import NumericInput from "../../../components/forms/react-hook-numeric-input";
import FormHookDatePicker from "../../../components/forms/form-hook-date-picker";
import ReactHookFormDropdown from "../../../components/forms/react-hook-dropdown";
import {
  useLookupCities,
  useLookupCountries,
  useLookupEmirates,
  useLookupRegions,
} from "../../../services/lookups-mutations";

export default function Information({
  onNextStep,
  currencies,
  control,
  errors,
  resetField,
  watch,
  setValue,
  handleSubmit,
}) {
  const { mutate: getCountries, data: countriesListRes } = useLookupCountries();
  const { mutate: getRegions, data: regionsListRes } = useLookupRegions();
  const { mutate: getEmirates, data: emiratesListRes } = useLookupEmirates();
  const { mutate: getCities, data: citiesListRes } = useLookupCities();

  useEffect(() => {
    getCountries();
  }, []);
  useEffect(() => {
    const countryCode = watch("country")?.code;
    if (countryCode && countryCode !== "0") {
      getRegions(countryCode);
      getCities(countryCode);
      getEmirates(countryCode);
    }
  }, [watch("country")]);
  const generalFieldProps = { control, errors };
  const formValidationRules = {
    name: { required: "Please Enter Name" },
    type: { required: "Please Select Type" },
    primaryCurrency: { required: "Please Select Currency" },
    barcode: { required: "Please Enter Barcode" },
    locationId: { required: "Please Enter Location" },
    status: { required: "Please Select Status" },
  };

  const onLoadingBayAreaChange = (e) => {
    if (e.target.value.id === "0") {
      resetField("loadingBayCapacity");
    }
  };
  const onCountryChange = () => {
    setValue("state", "");
    setValue("city", "");
    setValue("emirate", "");
  };
  return (
    <>
      <Flex w="100%" justify="space-between" flexDirection="row">
        <Heading style={{ width: "100%" }}>Cash Center Information</Heading>
        <Flex w="100%" justify="flex-end" flexDirection="row">
          <Flex
            w="100%"
            justify="flex-end"
            flexDirection="row"
            onClick={handleSubmit(onNextStep)}
          >
            <Button>Next</Button>
          </Flex>
        </Flex>
      </Flex>
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Name"
        name="name"
        rules={formValidationRules.name}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Type"
        name="type"
        id="id"
        text="text"
        data={CASH_CENTER_TYPES}
        placeholder="Select Type"
        rules={formValidationRules.type}
        dropdownProps={{ filterable: false }}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Primary Currency"
        name="primaryCurrency"
        id="shortName"
        text="name"
        data={currencies || []}
        placeholder="Select Currency"
        rules={formValidationRules.primaryCurrency}
        dropdownProps={{ filterable: true }}
        filterable
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Barcode"
        name="barcode"
        rules={formValidationRules.barcode}
      />
      <FormInput
        {...generalFieldProps}
        isRequired
        label="Location Id"
        name="locationId"
        rules={formValidationRules.locationId}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        isRequired
        label="Status"
        name="status"
        id="id"
        text="text"
        data={CASH_CENTER_STATUS}
        placeholder="Select Status"
        rules={formValidationRules.status}
        dropdownProps={{ filterable: false }}
      />
      <NumericInput {...generalFieldProps} label="Longitude" name="longitude" />
      <NumericInput {...generalFieldProps} label="Latitude" name="latitude" />
      <ReactHookFormDropdown
        {...generalFieldProps}
        label="Loading Bay Area"
        name="loadingBayArea"
        id="id"
        text="text"
        data={LOADING_BAY_AREAS}
        placeholder="Select Area"
        dropdownProps={{ filterable: false }}
        onChange={onLoadingBayAreaChange}
      />
      <NumericInput
        {...generalFieldProps}
        disabled={!watch("loadingBayArea")}
        label="Loading Bay Capacity"
        name="loadingBayCapacity"
        info={
          !watch("loadingBayArea") ? "Select Loading Bay Area To Enable" : ""
        }
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        label="Country"
        name="country"
        id="code"
        text="name"
        data={countriesListRes?.data || []}
        placeholder="Select Country"
        dropdownProps={{ filterable: true }}
        onChange={onCountryChange}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        disabled={!watch("country")}
        label="State"
        name="state"
        id="id"
        text="text"
        data={
          regionsListRes?.data.map((elm) => ({
            id: elm.name,
            text: elm.name,
          })) || []
        }
        placeholder="Select State"
        dropdownProps={{ filterable: true }}
        info={!watch("country") ? "Select country To Enable" : ""}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        disabled={!watch("country")}
        filterable
        label="City"
        name="city"
        id="id"
        text="text"
        data={
          citiesListRes?.data.map((elm) => ({
            id: elm.name,
            text: elm.name,
          })) || []
        }
        placeholder="Select City"
        dropdownProps={{ filterable: true }}
        info={!watch("country") ? "Select country To Enable" : ""}
      />
      <ReactHookFormDropdown
        {...generalFieldProps}
        disabled={!watch("country")}
        label="Emirate"
        name="emirate"
        id="id"
        text="text"
        data={
          emiratesListRes?.data.map((elm) => ({
            id: elm.name,
            text: elm.name,
          })) || []
        }
        placeholder="Select Emirate"
        dropdownProps={{ filterable: true }}
        info={!watch("country") ? "Select country To Enable" : ""}
      />
      <FormInput {...generalFieldProps} label="Postal Code" name="postalCode" />
      <FormInput {...generalFieldProps} label="Address " name="address" />
      <FormHookDatePicker
        {...generalFieldProps}
        label="First Service Date"
        name="firstServiceDate"
      />
      <FormHookDatePicker
        {...generalFieldProps}
        label="In Active Date"
        name="inactiveDate"
      />
      <FormControl>
        <FormLabel>Service Days</FormLabel>
        <Controller
          control={control}
          name="serviceDays"
          render={({ field }) => (
            <MultiSelect
              value={field.value}
              data={WEEK_DAYS}
              filterable={false}
              onChange={(e) => {
                field.onChange(e.target.value);
              }}
            />
          )}
        />
      </FormControl>
    </>
  );
}
